import { render, staticRenderFns } from "./notify.vue?vue&type=template&id=9324bc1c&"
import script from "./notify.vue?vue&type=script&lang=js&"
export * from "./notify.vue?vue&type=script&lang=js&"
import style0 from "./notify.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideYTransition } from 'vuetify/lib'
installComponents(component, {
  VSlideYTransition,
})
